import { KeyValueDefault } from '@/main/models/common';

export enum IntegrationQueueStatusTypes {
  GET_INTEGRATION_QUEUE_STATUS = '@integrationQueueStatus/GET_INTEGRATION_QUEUE_STATUS',
  SAVE_INTEGRATION_QUEUE_STATUS = '@integrationQueueStatus/SAVE_INTEGRATION_QUEUE_STATUS',
  RESET_REDUCER_INTEGRATION_QUEUE_STATUS = '@integrationQueueStatus/RESET_REDUCER_INTEGRATION_QUEUE_STATUS'
}

export interface IntegrationQueueStatusState {
  readonly integrationQueueStatus: {
    data: KeyValueDefault[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetIntegrationQueueStatus {
  type: typeof IntegrationQueueStatusTypes.GET_INTEGRATION_QUEUE_STATUS;
}

export interface SaveIntegrationQueueStatus {
  type: typeof IntegrationQueueStatusTypes.SAVE_INTEGRATION_QUEUE_STATUS;
  payload: {
    data: KeyValueDefault[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerIntegrationQueueStatus {
  type: typeof IntegrationQueueStatusTypes.RESET_REDUCER_INTEGRATION_QUEUE_STATUS;
}

export type IntegrationQueueStatusActionTypes =
  | GetIntegrationQueueStatus
  | SaveIntegrationQueueStatus
  | ResetReducerIntegrationQueueStatus;

